import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import styled from "@emotion/styled";
import Error from "../error-msg";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useState, useEffect } from "react";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});

const useStyles = styled((theme) => ({
  root: {
    width: 500,
    "& > * + *": {
      marginTop: theme.spacing(3),
    },
  },
}));

export default function ComboBox({
  id,
  placeholder,
  label,
  options = [],
  error = false,
  errorMsg,
  sx,
  multiple = false,
  inputProps = false,
  tooltipText,
  getValue,
  val = null,
  type = "none",
}) {
  const classes = useStyles();

  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
    setTimeout(() => {
      setOpen(false);
    }, 7000)
  };

  useEffect(() => {
    setValue(val);
  }, [val]);

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <FormControl fullWidth>
        <div className={classes.root}>
          <Autocomplete
            multiple={multiple}
            limitTags={5}
            id={id}
            options={options}
            getOptionLabel={(option) =>
              type === "dialCode"
                ? option.dial_code + " " + option.label
                : option.label
            }
            sx={sx}
            value={value}
            onChange={(e, v) => {
              if (v !== null) {
                getValue(v);
              }
            }}
            key={(option) => option.id}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={label}
                error={error}
                placeholder={placeholder}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: inputProps ? (
                    <InputAdornment position="start">
                      <CustomWidthTooltip
                        title={tooltipText}
                        open={open}
                      >
                        <InfoIcon
                          sx={{
                            fontSize: "20px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            color: "#6d4cb1",
                          }}
                          onClick={handleClick}
                        />
                      </CustomWidthTooltip>
                    </InputAdornment>
                  ) : null,
                }}
              />
            )}
          />
        </div>
      </FormControl>
      {error && <Error errorMsg={errorMsg} />}
    </div>
  );
}
